import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup, Modal, ModalBody, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import Edit from "@material-ui/icons/Edit";
import {Objects} from "../index";
import UserRoles from "../../constants/UserRoles";
import Collections from "./index";
import LaunchIcon from '@material-ui/icons//Launch';


export default class IdleTasks extends Framework.Components.Collection {
	constructor(props) {
		const model = new API.BuildClass(Types.Recurring_Tasks._name, API.RequestType.READ_ALL);
		super(props, model);

		this.state = {
			...this.state,
			limit: 20,
			modalCount: false,
			modalEdit: false,
		};
	}

	async componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.filter !== this.props.filter) {
			await this.fetchData(this.state)
		}
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]});
	};

	fetchData = async (state) => {
		this.state.limit = 20;
		this.state.sorted = [];
		this.state.page = 0;
		if (!this.state.filter || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}

		this.state.filter.type = this.props.filter;
		this.state.filter.isAtLeastManager = this.props.isAtLeastManager;

		this.setState({loading: true});
		setTimeout(() => this.fetchDataActual(state, ['order']), 100);
	};

	handleLinkClick = async (task) => {
		let model = API.BuildClass(Types.Recurring_Tasks_Clicked._name , API.RequestType.CREATE)
		model.object.task = task;
		model.object.user = this.props.user;
		await model.submit(null, "PUT",true)
		await this.fetchData(this.state);
	}

	getColumns = () => {
		const columns = [
			{
				Header: "Title",
				accessor: "title",
				style: {
					whiteSpace: "normal", // Allow text to wrap
					wordWrap: "break-word",
				},
			},
			// {
			// 	Header: "Description",
			// 	accessor: "description",
			// 	style: {
			// 		whiteSpace: "normal", // Allow text to wrap
			// 		wordWrap: "break-word",
			// 	},
			// },
			{
				Header: "",
				accessor: "link",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: (props) => {
					const value = props.original.link
					if (!value) return <span></span>;

					const isFullUrl = /^https?:\/\//i.test(value);
					const isDomainOnly = /^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(value);
					const launchButton = (
						<Button color="green-meadow" size={"sm"} block={true}>
							<LaunchIcon fontSize={'small'}/></Button>
					)

					if (isFullUrl) {
						return (
							<a
								href={value}
								rel="noopener noreferrer"
								onClick={async (e) => {
									e.preventDefault();
									await this.handleLinkClick(props.original.pkey);
									window.location.href = value;
								}}
							>
								{launchButton}
							</a>

						);
					}

					if (isDomainOnly) {
						return (
							<a
								href={`https://${value}`}
								rel="noopener noreferrer"
								onClick={async (e) => {
									e.preventDefault();
									await this.handleLinkClick(props.original.pkey);
									window.location.href = `https://${value}`;
								}}
							>
								{launchButton}
							</a>

						);
					}


					return (
						<a
							href={`/${value.replace(/^\/+/, "")}`}
							onClick={async (e) => {
								e.preventDefault();
								await this.handleLinkClick(props.original.pkey);
								this.props.history.push(`/${value.replace(/^\/+/, "")}`);
							}}
						>
							{launchButton}
						</a>

					);
				},
			},
		];

		if (this.props.isAtLeastManager) {
			columns.push(
				{
					Header: "Active",
					accessor: "active",
					Cell: props => {
						return (
							<div style={{textAlign: 'center'}}>
								<Checkbox
									checked={!!props.original.active}
									onChange={async () => {
										await this.updateTaskActive(props.original)
									}}
									color={'primary'}
								/>
							</div>
						);
					},
					width: 80,
				},
				{
					Header: "Departments",
					accessor: "roles_array",
					Cell: ({value}) =>
						value ? JSON.parse(value) ? JSON.parse(value).join(', ') : "All Departments" : "All Departments",
				},
				{
					Header: "Count",
					accessor: "count",
					width: 100,
					Cell: (props) => (
						<Button
							color="link"
							onClick={() =>
								this.setState({modalCount: true, idle_task_filter: props.original.pkey})
							}
						>
							{props.original.count ?? 0}
						</Button>
					),
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						return (
							<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
									this.setState({idle_task_edit: props.original.pkey, modalEdit: true})
								}
							}>
								<Edit fontSize={'small'}/></Button>

						);
					}
				},
			);
		}

		return columns;
	};

	updateCurrentOrder = async (order) => {
		let model = API.BuildClass(Types.Recurring_Tasks_Order._name , API.RequestType.UPDATE)
		model.object.current_order = order;
		model.object.role = this.props.filter;
		await model.submit(null, "POST",true)
		await this.fetchData(this.state);
	}

	updateTaskActive = async (task) => {
		let model = API.BuildClass(Types.Recurring_Tasks._name , API.RequestType.UPDATE)
		model.object = task;
		model.object.active = !task.active;
		await model.submit(null, "POST",true)
		await this.fetchData(this.state);
	}

	renderManagerControls() {
		if (!this.props.isAtLeastManager) return null;

		return (
			<div style={{marginTop: 5}}>
				<b>Order for this Department: </b>
				<ButtonGroup size={"md"}>
					<Button
						id={"Random"}
						onClick={async (event) => {
							await this.updateCurrentOrder(event.currentTarget.id);
						}}
						outline={this.state.order !== "Random"}
						active={this.state.order === "Random"}
						color={'primary'}
					>
						Random
					</Button>
					<Button
						id={"Least Clicked"}
						onClick={async (event) => {
							await this.updateCurrentOrder(event.currentTarget.id);
						}}
						outline={this.state.order !== "Least Clicked"}
						active={this.state.order === "Least Clicked"}
						color={'primary'}
					>
						Least Clicked
					</Button>
				</ButtonGroup>
			</div>
		);
	}

	render() {
		const {data, loading} = this.state;

		return (
			<div className="box-body">
				{this.renderManagerControls()}

				<Card>
					<CardContent>
						<ReactTable
							columns={this.getColumns()}
							data={data}
							loading={loading}
							onFetchData={this.fetchData}
							manual
							getTdProps={() => ({
								style: {
									paddingTop: 0,
									paddingBottom: 0,
									height: 40,
									display: "flex",
									alignItems: "center",
								},
							})}



							showPagination={false}
							pageSize={data.length || 0}
							minRows={0}

							className="-striped -highlight"
						/>
						<Framework.Elements.LoadingSpinner
							isLoading={loading}
						/>
					</CardContent>
				</Card>

				{/* Count Modal */}
				<Framework.Elements.UniversalModal
					size={"xl"}
					title={"Idle Task Click History"}
					object={Collections.IdleTasksClicked}
					toggle={this.state.modalCount}
					reportClose={() => {
						this.setState({idle_task_filter: null})
						this.handleToggleModal('modalCount')
					}}
					hideGoTo={true}
					hasSubmit={false}
					objectProps={{task: this.state.idle_task_filter}}
				/>

				{/* Edit Modal */}
				<Framework.Elements.UniversalModal
					name={"Idle Task"}
					object={Objects.IdleTask}
					toggle={this.state.modalEdit}
					reportClose={() => {
						this.setState({idle_task_edit: null})
						this.handleToggleModal('modalEdit')
					}}
					id={this.state.idle_task_edit}
					afterSave={async () => {
						this.setState({idle_task_edit: null})
						await this.fetchData(this.state)
					}}
					objectProps={{allowed_roles: this.props.all_roles}}
					title={"Update Idle Task"}
					hideGoTo={true}
				/>
			</div>
		);
	}
}
